import CodeMirror from 'codemirror';
import { createSpanReplacementNode } from '../markers/utils';
import { getCloseBracketPosition, splitTokensWithComma, hasTokenIncludes } from '../utils/codemirror';


function isIdToken(token: CodeMirror.Token) {
  return hasTokenIncludes(token, ['declaration', 'Id']);
}

export function replaceAtomIdArray(
  editor: CodeMirror.Editor,
  tokens: CodeMirror.Token[],
  idx: number
) {
  const token = tokens[idx];
  if (!token) { return 0; }

  if (token.type === 'bracket' && token.string === '[') {
    // Id数组
    const closeBracketIndex = getCloseBracketPosition(tokens, idx, '[', ']');

    if (closeBracketIndex > -1) {
      const tokensArr = splitTokensWithComma(tokens.slice(idx + 1, closeBracketIndex));
      const endToken = tokens[closeBracketIndex];
      if (tokensArr.length > 0 && tokensArr.every(tokens => isIdToken(tokens[0]))) {
        const line = token.state.line;
        const startPos = { line, ch: token.start };
        const endPos = { line, ch: endToken.end };

        const atomIdValues = tokensArr.map(token => {
          const matched = token[0].string.match(/^Id\((.*)\)$/);
          const id = matched ? matched[1] : token[0].string;
          return (id.startsWith('"') || id.startsWith('\'')) ? id.slice(1, -1) : id;
        });

        // const frontIdValue = atomIdValues.slice(0, 5).join(',');

        // const frontIdText = frontIdValue.length > 20 ? frontIdValue.slice(0, 20) + '…' : frontIdValue;

        // const replacement = '[' + (tokensArr.length > 5 ? `${frontIdText}等${tokensArr.length}条数据` : frontIdText) + ']';
        // const replacement = `共筛选${tokensArr.length}条明细数据`;
        const replacement = `[${atomIdValues.join(',')}]`;

        editor.getDoc().markText(startPos, endPos, {
          replacedWith: createSpanReplacementNode(
            replacement,
            'cm-declaration'
          )
        });
        return closeBracketIndex - idx + 1;
      }
    }
  }


  return 0;
}
